export default __webpack_public_path__ + "static/media/bg-header.dd5ef236.png";